import React from "react";
import { Route, Switch, BrowserRouter as Router, Link } from "react-router-dom";
import styles from './css/styles.module.css';
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { makeStyles, MuiThemeProvider } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import List from "@material-ui/core/List";
import CssBaseline from "@material-ui/core/CssBaseline";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import Fab from '@material-ui/core/Fab';
import MenuItem from '@material-ui/core/MenuItem';
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Button from '@material-ui/core/Button';
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import cargoesLogo from './images/Cargoes.png';
import docuwareIcon from './icons/magnifying-glass.svg';
import notificationIcon from './icons/Bell.svg';
import jsonIcon from './icons/Json.svg';
import facilityManagemet from './icons/Facility Management.svg';
import clientListImg from './icons/Checklist.svg'
import configurationIcon from './icons/Docuware.svg';
import messageIcon from './icons/Chat.svg';
import emailIcon from './icons/Envelope.svg';
import esignIcon from './icons/esign.svg';
import homeIcon from './icons/Home.svg';
import documentIcon from './icons/Document.svg';
import { ProtectedRoute } from './utils/ProtectedRoutes';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { _routes, _administrator } from "../src/utils/Routes";
import EmailTemplate from "../src/components/EmailTemplate";
import CreateTemplate from "../src/components/CreateTemplate";
import Template from "../src/components/Template";
import HtmlTemplate from "../src/components/HtmlTemplate";
// import JsonTemplate from "../src/components/JsonTemplate";
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import lightTheme from "./themes/lightTheme";
import MainPage from "../src/components/Docuware/MainPage";
import Configurations from "./components/Docuware/Configurations";
import RecycleBin from "./components/Docuware/RecyleBin/RecycleBin";
import Storage from "./components/Docuware/Storage";
import viewClients from "./components/ViewClients";
import ClientDetails from "../src/components/ClientDetails";
import addCustomFieldDashboard from "../src/components/AddCustomField";
import NewFolder from "./components/Docuware/configuration/NewFolder";
import UpdateFolder from "./components/Docuware/configuration/UpdateFolder";
import darkTheme from "./themes/default-theme";
import AuthService from "./services/AuthService";
import authUtil from "./utils/AuthUtils";
import notify from "./utils/notifier";
import Card from "@material-ui/core/Card";
import getWorkspaces from "./services/user/getWorkspaces";
import getUserInfo from "./services/user/getUserInfo";
import getPrivileges from "./services/user/getPrivileges";
import Unauthorized from "../src/components/Unauthorized";
import { setCompanyDetails, setUserDetails, setClientDetails } from "./utils/user";
import UserProfileDropdown from "./components/onboard/UserProfileDropdown";
import ConfigureSettings from "./components/ConfigureSettings";
import ChangeCompanyModal from "./components/ChangeCompanyModal";
import CircularProgress from '@material-ui/core/CircularProgress';
import { USER_ROLES_MAP, CRP_MANGE_COMPANY_ENV_URLS } from './utils/constants'
import ESignDashboard from "../src/components/signing/ESignDashboard";
import GetSignatures from "../src/components/signing/GetSignatures";
import RagAssistant from "./components/RagAssistant";
import RagDashboard from "./components/RagDashboard";
import Collapse from '@material-ui/core/Collapse';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import CloseIcon from '@material-ui/icons/Close';
import HelpIcon from '@material-ui/icons/Help';
import Util from "./utils/Util";
const env = Util.getEnv();
// TODO: read from session context and update currentTheme.
// const currentTheme = darkTheme;
const icons = {
    "Home": <img src={homeIcon} alt="React Logo" />,
    "Docx Templates": <img src={documentIcon} alt="React Logo" />,
    "E-Sign": <img src={esignIcon} alt="React Logo" />, // Add this line
    // "Json Templates": <img src={jsonIcon} alt="React Logo" />,
    "HTML Templates": <img src={jsonIcon} alt="React Logo" />,
    "Document Suite": <img src={docuwareIcon} alt="React Logo" />,
    "Configuration": <img src={configurationIcon} alt="React Logo" />,
    "Administrator": <img src={facilityManagemet} alt="React Logo" />,
    "View Clients": <img src={clientListImg} alt="React Logo" />,
    "Add Custom Field": <img src={clientListImg} alt="React Logo" />,
    "AI Assistant": <img src={messageIcon} alt="AI Assistant" />,
    "RAG Dashboard": <img src={configurationIcon} alt="RAG Dashboard" />
}
const DEFAULT_LANG = "EN";
let currentTheme =
    localStorage.getItem("currentTheme") === "darkTheme" ? darkTheme : lightTheme;

const drawerWidth = 280;
const useStyles = makeStyles(theme => ({
    root: {
        display: "flex"
    },
    iconColor: {
        color: "white"
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(["width", "margin"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        })
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(["width", "margin"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen
        })
    },
    menuButton: {
        marginRight: 36
    },
    hide: {
        display: "none"
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: "nowrap"
    },
    drawerOpen: {
        width: drawerWidth,
        transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen
        }),
        background: currentTheme.palette.primary.main,
    },
    drawerClose: {
        transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        }),
        overflowX: "hidden",
        width: theme.spacing(7) + 1,
        [theme.breakpoints.up("sm")]: {
            width: theme.spacing(9) + 1
        },
        background: currentTheme.palette.primary.main,
    },
    toolbar: {
        display: "flex",
        background: currentTheme.palette.primary.main,
        alignItems: "center",
        justifyContent: "flex-start",
        padding: theme.spacing(0, 1),
        ...theme.mixins.toolbar
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
        marginTop: 55
    },
    displayContents: {
        display: "contents",
        textDecoration: "none",
        color: "white",
    },
    MuiBackdrop: {
        backgroundColor: "#fafafa"
    },
    flexGrow0: {
        flexGrow: 0
    },
    flexGrow1: {
        flexGrow: 1
    },
    wrapper: {
        position: "relative"
    },
    paper: {
        position: "absolute",
        top: 56,
        right: -24,
        maxHeight: 400,
        padding: theme.spacing(1),
        backgroundColor: currentTheme.palette.primary.main,
        padding: 2,
        overflow: "scroll",
    },
    card: {
        minWidth: 100,
        height: "100%"
    },
    flexItem: {
        display: "flex"
    },
    setting: {
        padding: "20px 0px"
    },
    customSelect: {
        fontSize: "x-large",
        width: "100%",
        border: "none",
        margin: "5px"
    }
}));

export default function AdminApp(props) {
    const [t, i18n] = useTranslation();
    const classes = useStyles();
    const routes = _routes;

    const [open, setOpen] = React.useState(false);
    const [openList, setOpenList] = React.useState(false);
    const [loggedInClientName, setLoggedInClientName] = React.useState('');
    const [userInitials, setUserInitials] = React.useState('');
    const [company, setCompany] = React.useState('');
    const [isChangeCompanyModalOpen, setIsChangeCompanyModalOpen] = React.useState(false);
    const [isHelpAssistantOpen, setIsHelpAssistantOpen] = React.useState(false);
    const [companies, setCompanies] = React.useState([]);
    const [currentCompanyIndex, setCurrentCompanyIndex] = React.useState(() => {
        const savedIndex = localStorage.getItem("company_index");
        return savedIndex ? Number(savedIndex) : 0;
    });
    const [companyRef, setCompanyRef] = React.useState('');
    const [error, setError] = React.useState(false);
    const [isInitialized, setIsInitialized] = React.useState(false);
    const [userDetails, setUserDetailsState] = React.useState({
        userInitials: '',
        fullName: '',
        role: '', // Default role, can be updated from actual user data
        emailAddress: ''
    });
    const [administratorRoutes, setAdministratorRoutes] = React.useState(_administrator);
    const [openAdminList, setOpenAdminList] = React.useState(false);
    const [filteredRoutes, setFilteredRoutes] = React.useState(_routes);

    const [privileges, setPrivileges] = React.useState({
        services: [],
        privileges: []
      });

    const [lang, setLang] = React.useState(
        localStorage.getItem("currentLanguage") || DEFAULT_LANG
    );
    const [curTheme, setCurTheme] = React.useState(
        localStorage.getItem("currentTheme") || "lightTheme"
    );
    const handleDrawerOpen = () => {
        setOpen(true);
    };
    const handleDrawerClose = () => {
        setOpen(false);
        setOpenList(false);
        setOpenAdminList(false);
    };
    const handleAdministratorList = () => {
        setOpenAdminList(!openAdminList);
    };
    const handleChangeCompany = () => {
        setIsChangeCompanyModalOpen(true);
    };
    const handleOpenHelpAssistant = () => {
        setIsHelpAssistantOpen(true);
    };
    const handleClickLogout = () => {
        authUtil.logout();
        window.location.href = `${window.location.origin}/login`;
    };

    const redirectTo = (url) => {
        if (!url) return;
        window.location.href = url; // full redirect (external app)
        // OR: window.open(url, "_self");
    };

    const updateUserPrivileges = () => {
        let _userPrivileges = {};
        
        let loggedInClient = authUtil.getClientInfo();
        let adminPrivileges = loggedInClient === 'admin' || loggedInClient === 'datachain';
        
        if (adminPrivileges) {
            _userPrivileges['/viewClients'] = true;
            _userPrivileges['/addCustomField'] = true;
            _userPrivileges['/rag/dashboard'] = true;
        }
        // Keep all routes for the main navigation
        setFilteredRoutes(_routes);
        // Only filter administrator routes for the sidebar
        setAdministratorRoutes(_administrator.filter(r => Object.keys(_userPrivileges).includes(r.route)));
    };

    const handleChangeCompanySubmit = async (newCompanyRef) => {
        try {
            const newIndex = companies.findIndex(company => company.companyOverview.companyReference === newCompanyRef);
            if (newIndex === -1) {
                throw new Error('Selected company not found');
            }
            
            if (newIndex !== -1) {
                const selectedCompany = companies[newIndex];
                const newCompanyName = selectedCompany.companyOverview.companyName;
                const newCompanyRef = selectedCompany.companyOverview.companyReference;
    
                // Update localStorage
                localStorage.setItem('company_name', newCompanyName);
                localStorage.setItem('company_ref', newCompanyRef);
                
                setCompany(newCompanyName);
                setCompanyRef(newCompanyRef);
                
                // Get and set new user info
                const userDetails = await getUserInfo(newCompanyRef);
                const userEmail = userDetails ? userDetails.emailAddress : null;
                // Store clientTypeCode in localStorage
                if (userDetails.clientTypeCode) {
                    localStorage.setItem('client_type_code', userDetails.clientTypeCode);
                    const documentPrivileges = await getPrivileges(newCompanyRef, userDetails.clientTypeCode);
                    setPrivileges(documentPrivileges);
                    updateUserPrivileges();
                }
                else {
                    throw new Error('clientTypeCode not found in user details');
                }


                setUserDetails(userDetails);

                setUserDetailsState({
                    userInitials: userDetails.userInitials,
                    fullName: userDetails.fullName,
                    role: USER_ROLES_MAP[userDetails.clientTypeCode] || 'Role not found', // Use role from API or default
                    emailAddress : userDetails.emailAddress
                });
                
                // Store user email in localStorage for audit tracking
                if (userDetails.emailAddress) {
                    localStorage.setItem('_userEmail', userDetails.emailAddress);
                }
                // Set client details
                setClientDetails(newCompanyName);
                
                // Update documentServiceIntegration token
                const documentServiceIntegrationtoken = await authUtil.generateToken(newCompanyName, userEmail);
                authUtil.setSession(documentServiceIntegrationtoken);

                setCurrentCompanyIndex(newIndex);
                setCompanyDetails(newCompanyRef, newCompanyName, newIndex);

                // Close modal
                setIsChangeCompanyModalOpen(false);
    
                // Show success message
                notify({
                    type: "success",
                    message: "Company changed successfully"
                  });
    
            }
        } catch (error) {
            notify({
                type: "error",
                message: "Failed to change company"
              });
            console.error('Error changing company:', error);
        }
    };


    React.useEffect(() => {
        async function initializeApp(currentCompanyIndex) {
          try {
            const workspaceDetails = await getWorkspaces();
            const companyRef = workspaceDetails[currentCompanyIndex] ? workspaceDetails[currentCompanyIndex].companyOverview.companyReference : 'NA';
            const companyName = workspaceDetails[currentCompanyIndex] ? workspaceDetails[currentCompanyIndex].companyOverview.companyName : 'NA';
            setCompanyDetails(companyRef, companyName, currentCompanyIndex);
            setCompany(companyName);
            setCompanies(workspaceDetails);
    
            const userDetails = await getUserInfo(companyRef);
            // Store clientTypeCode in localStorage
            if (userDetails.clientTypeCode) {
                localStorage.setItem('client_type_code', userDetails.clientTypeCode);
                const documentPrivileges = await getPrivileges(companyRef, userDetails.clientTypeCode);
                setPrivileges(documentPrivileges);
                updateUserPrivileges();
            }
            else {
                throw new Error('clientTypeCode not found in user details');
            }

            setUserDetails(userDetails);
            setUserDetailsState({
            userInitials: userDetails.userInitials,
            fullName: userDetails.fullName,
            role: USER_ROLES_MAP[userDetails.clientTypeCode] || 'FS Super Admin',
            emailAddress: userDetails.emailAddress
            });
            setUserInitials(userDetails.userInitials);
            setLoggedInClientName(userDetails.fullName);
    
            setClientDetails(companyName);
            
            const documentServiceIntegrationtoken = await authUtil.generateToken();
            authUtil.setSession(documentServiceIntegrationtoken);
    
            // Set initialized to true
            setIsInitialized(true);
          } catch (error) {
            console.error('Error in AdminApp initialization:', error);
            setError(true);
            // Handle error (e.g., redirect to login, show error message)
          }
        }
    
        initializeApp(currentCompanyIndex);
      }, [currentCompanyIndex]);

      if (!isInitialized) {
        return (
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
            {error ? (
              <ConfigureSettings />
            ) : (
              <CircularProgress />
            )}
          </div>
        );
      }

    return (
        <MuiThemeProvider theme={currentTheme}>
            <Router>
                <div className={classes.root} >
                    <CssBaseline />
                    <AppBar
                        position="fixed"
                        className={clsx(classes.appBar, {
                            [classes.appBarShift]: open
                        })}
                    >
                        <Toolbar >
                            <IconButton
                                color="inherit"
                                aria-label="open drawer"
                                onClick={handleDrawerOpen}
                                edge="start"
                                className={clsx(classes.menuButton, {
                                    [classes.hide]: open
                                })}
                            >
                                <MenuIcon />
                            </IconButton>
                            <Typography variant="h6" noWrap className={classes.flexGrow1}>
                                {t("Document Service")}
                            </Typography>
                            <div className={classes.flexGrow0} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <Button
                                    color="inherit"
                                    onClick={handleOpenHelpAssistant}
                                    startIcon={<HelpIcon />}
                                    size="small"
                                    style={{ textTransform: 'none' }}
                                >
                                    Help
                                </Button>
                                <UserProfileDropdown 
                                    initials={userDetails.userInitials}
                                    name={userDetails.fullName}
                                    email={userDetails.emailAddress}
                                    company={company}
                                    role={userDetails.role}
                                    onLogout={handleClickLogout}
                                    onEditCompany={handleChangeCompany}
                                    onManageUsers={() => {redirectTo(CRP_MANGE_COMPANY_ENV_URLS[env].manageUsers)}}
                                    onManageCompany={() => {redirectTo(CRP_MANGE_COMPANY_ENV_URLS[env].manageCompany)}}
                                />
                            </div>
                        </Toolbar>
                    </AppBar>
                    <Drawer
                        onMouseEnter={handleDrawerOpen}
                        onMouseLeave={handleDrawerClose}
                        variant="permanent"
                        className={clsx(classes.drawer, {
                            [classes.drawerOpen]: open,
                            [classes.drawerClose]: !open
                        })}
                        classes={{
                            paper: clsx({
                                [classes.drawerOpen]: open,
                                [classes.drawerClose]: !open
                            })
                        }}
                        open={open}
                    >
                        <div className={classes.toolbar}  >
                            {currentTheme.direction === "rtl" ? (
                                <IconButton onClick={handleDrawerClose}>
                                    <ChevronRightIcon className={classes.iconColor} />
                                </IconButton>) : (
                                <div style={{ color: "white" }}>
                                    <img src={cargoesLogo} alt='DPW' style={{ height: "1.2em", verticalAlign: "sub" }} /> &nbsp;<b>DOCUMENT SERVICE </b>
                                </div>
                            )}
                        </div>
                        <Divider />
                        <List >
                            {filteredRoutes.map((route, index) => (
                                <ListItem button key={route.title} >
                                    <Link to={route.route} className={classes.displayContents}>
                                        <ListItemIcon className={classes.iconColor}>
                                            {icons[route.title]}
                                        </ListItemIcon>
                                        {open ? <ListItemText primary={t(route.title)} /> : ""}
                                    </Link>
                                </ListItem>
                            ))}
                            {
                                administratorRoutes.length ?
                                <ListItem button onClick={handleAdministratorList} >
                                    <ListItemIcon className={classes.iconColor}>
                                        {icons['Administrator']}
                                    </ListItemIcon>
                                    <ListItemText primary="Administrator" className={classes.displayContents} />
                                    {openAdminList ? <ExpandLess /> : <ExpandMore />}
                                </ListItem>
                                : ""
                            }
                            <Collapse in={openAdminList} timeout="auto" unmountOnExit>
                                <List component="div" disablePadding style={{ paddingLeft: "1.5em" }}>
                                    {
                                        administratorRoutes.map((route, index) => (
                                            <Link to={route.route} className={classes.displayContents} key={route.title}>
                                            <ListItem button>
                                                <ListItemIcon className={classes.iconColor}>
                                                {icons[route.title]}
                                                </ListItemIcon>
                                                <ListItemText primary={route.title} />
                                            </ListItem>
                                            </Link>
                                        ))
                                    }
                                </List>
                            </Collapse>
                        </List>
                    </Drawer>
                    <main className={classes.content}>
                        <ToastContainer />
                        <Switch>
                            <ProtectedRoute 
                                exact 
                                path="/"
                                currentCompany={companies[currentCompanyIndex]}
                                component={Template}
                            />
                            <ProtectedRoute 
                                exact 
                                path="/templates" 
                                currentCompany={companies[currentCompanyIndex]}
                                // Example of adding required privileges
                                requiredPrivileges={["DOC_TEMP_VW"]} 
                                component={Template}
                            />
                            <ProtectedRoute 
                                exact 
                                path="/e-sign" 
                                // requiredPrivileges={["DOC_ESIGN_ACCESS"]}
                                component={ESignDashboard} 
                            />
                            <ProtectedRoute 
                                exact 
                                path="/e-sign/create" 
                                // requiredPrivileges={["DOC_ESIGN_CREATE"]}
                                currentCompany={companies[currentCompanyIndex]}
                                component={GetSignatures} 
                            />
                            <ProtectedRoute 
                                exact 
                                path="/e-sign/document/:id" 
                                // requiredPrivileges={["DOC_ESIGN_VIEW"]}
                                currentCompany={companies[currentCompanyIndex]}
                                component={GetSignatures} 
                            />
                            <ProtectedRoute 
                                exact 
                                path="/htmlTemplates" 
                                currentCompany={companies[currentCompanyIndex]}
                                requiredPrivileges={["DOC_TEMP_VW"]}
                                component={HtmlTemplate} 
                            />
                            {/* <ProtectedRoute 
                                exact 
                                path="/jsonTemplates" 
                                requiredPrivileges={["DOC_TEMP_VW"]}
                                component={JsonTemplate} 
                            /> */}
                            <ProtectedRoute 
                                exact 
                                path="/createTemplate" 
                                requiredPrivileges={["DOC_TEMP_UPLOAD"]}
                                component={CreateTemplate} 
                            />
                            <ProtectedRoute 
                                exact 
                                path="/document-suite" 
                                currentCompany={companies[currentCompanyIndex]}
                                requiredPrivileges={["DS_FILE_VIEW"]} 
                                component={MainPage} 
                            />
                            <ProtectedRoute 
                                exact 
                                path="/document-suite/configurations" 
                                currentCompany={companies[currentCompanyIndex]}
                                requiredPrivileges={["DS_CFG_VIEW"]} 
                                component={Configurations} 
                            />
                            <ProtectedRoute 
                                exact 
                                path="/document-suite/configurations/storage" 
                                currentCompany={companies[currentCompanyIndex]}
                                component={Storage} 
                            />
                            <ProtectedRoute 
                                exact 
                                path="/document-suite/documents/recyclebin"
                                requiredPrivileges={["DS_RECYC_DLT"]} 
                                currentCompany={companies[currentCompanyIndex]}
                                component={RecycleBin} 
                            />
                            <ProtectedRoute 
                                exact 
                                path="/document-suite/configurations/storage/newfolder"
                                requiredPrivileges={["DS_CFG_VIEW"]} 
                                component={NewFolder} 
                            />
                            <ProtectedRoute 
                            path="/document-suite/configurations/storage/update/:id" 
                            component={UpdateFolder} 
                        />
                            <ProtectedRoute 
                                exact 
                                path="/viewClients" 
                                component={viewClients} 
                            />
                            <ProtectedRoute 
                                exact 
                                path="/addCustomField" 
                                component={addCustomFieldDashboard} 
                            />
                            {/* RAG Assistant now accessible via profile dropdown modal */}
                            <ProtectedRoute 
                                exact 
                                path="/rag/dashboard" 
                                component={RagDashboard} 
                            />
                            <ProtectedRoute 
                                exact 
                                path="/clientDetails" 
                                component={ClientDetails} 
                            />
                            {/* Add route for unauthorized access */}
                            <Route path="/unauthorized" component={Unauthorized} />
                        </Switch>
                    </main>
                </div>
                <ChangeCompanyModal
                    open={isChangeCompanyModalOpen}
                    onClose={() => setIsChangeCompanyModalOpen(false)}
                    currentCompany={companyRef}
                    companies={companies.map(c => ({
                        companyReference: c.companyOverview.companyReference,
                        companyName: c.companyOverview.companyName
                    }))}
                    onSubmit={handleChangeCompanySubmit}
                />
                
                {/* Help Assistant Modal */}
                <Dialog
                    open={isHelpAssistantOpen}
                    onClose={() => setIsHelpAssistantOpen(false)}
                    maxWidth="lg"
                    fullWidth
                    PaperProps={{
                        style: { height: '80vh' }
                    }}
                >
                    <DialogTitle style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        Documentation Help Assistant
                        <IconButton onClick={() => setIsHelpAssistantOpen(false)} size="small">
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent style={{ padding: 0 }}>
                        <RagAssistant />
                    </DialogContent>
                </Dialog>
            </Router>
        </MuiThemeProvider>
    );
}
